import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class EsamparkServiceService {

  urlConfig: any;
  constructor(
    private http: HttpClient,
   // private config: AppConfigService,
   // private _commonSharing: CommonSharingService
  ) {
   // this.urlConfig = this.config.getConfig();
  }

  getMediaData(token:String): Observable<any[]> {
    return this.http
      .get<any[]>(
    //`http://localhost:7001/ESamparkWS/api/marketing-urls?token=${token}`
   //     `https://balicuat2.bajajallianzlife.com/ESamparkWS/api/marketing-urls?token=${token}`
        `https://salesperf.bajajallianzlife.com/ESamparkWS/api/marketing-urls?token=${token}`
      )
     // .pipe(catchError(this._commonSharing.handleError));
  }

  getSharableCustomerData(token:String): Observable<any> {
    //const token="/7XHbQCJ3sjo6RpdOmBe4A==";
    
    return this.http
      .get<any>(
      //  `http://localhost:7001/ESamparkWS/api/customer-agent-details?token=${token}`
      //  `https://balicuat2.bajajallianzlife.com/ESamparkWS/api/customer-agent-details?token=${token}`
        `https://salesperf.bajajallianzlife.com/ESamparkWS/api/customer-agent-details?token=${token}`
      )
     // .pipe(catchError(this._commonSharing.handleError));
  }


 
  shareSelectedDocToGetB64(obj: any): Observable<any[]> {
    return this.http.post<any[]>(
    //  `http://localhost:7001/ESamparkWS/api/image-with-text`,
    //  `https://balicuat2.bajajallianzlife.com/ESamparkWS/api/image-with-text`,
    `https://salesperf.bajajallianzlife.com/ESamparkWS/api/image-with-text`,
      obj,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }
  esmparkLogs(obj: any): Observable<any>
    {
      
      return this.http.post<any>(`https://salesperf.bajajallianzlife.com/ESamparkWS/api/logs-details
      `,obj)
      // return this.http.post<any>(`http://localhost:7001/ESamparkWS/api/logs-details
      // `,obj)
      // return this.http.post<any>(`https://balicuat2.bajajallianzlife.com/ESamparkWS/api/logs-details
      // `,obj)
      //.pipe(catchError(this._commonSharing.handleError));
      
    }
}
